<template>
  <freight-list :type="1"></freight-list>
</template>

<script>

import FreightList from "@view/components/freight/freight-list.vue";

export default {
  name: "freight",
  components: {FreightList},
  data() {
    return {}
  },
  mixins: [tableBase],
  methods: {},
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
